export default function () {
  return {
    uptime: undefined,
    autoNext: false,
    concorsiCleared: false,
    percorsiCleared: false,
  }
}
